import React from 'react'
import { Store } from '../../context/store'

const Network = ({ children }) => {
    const { actions } = Store()

    window.addEventListener('online', () => {
        actions.setOnline(true)
    })

    window.addEventListener('offline', () => {
        actions.setOnline(false)
    })

    return (
        <>
            {children}
        </>
    )
}

export default Network
